import React, { useState, useEffect, useRef } from "react";
import { Delete } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  FormControl,
  Box,
  InputAdornment,
  MenuItem,
  Chip,
} from "@material-ui/core";
import CardHeader from "../StyledComponents/Card/CardHeader";
import CardText from "../StyledComponents/Card/CardText";
import CardBody from "../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@material-ui/icons";
import moment from "moment";
import getParameterByName from "../Functions/functions";
import { useNavigate } from "react-router-dom";
import { dashboardStyle } from "../views/Invoices/Components/InvoiceDetails/style";
import CustomSnackbar from "../CustomSnackbar";
import Card from "../StyledComponents/Card/Card";
import { getUserRoles } from "../views/Home/actions";
import Heading from "../StyledComponents/Heading/Heading";
import InvoiceTextField from "../views/Invoices/Components/InvoiceDetails/InvoiceTextFields";
import CommentHistory from "../views/Invoices/NewInvoice/Tables/CommentHistory";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  getAllInvoiceDetailByInvoiceIdForDCReviewer,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  uploadAdditioalDocumentFile,
  LoamPutInvoice,
  getUsersByRole,
  deleteAttachment,
  getMethodForPageRefresh,
} from "../views/Invoices/actions";
import AttachmentsCover from "../components/Attachments/AttachmentsCover";
import GL_Table_ProcessInvoice from "../views/Invoices/NewInvoice/Tables/GL_Table_ProcessInvoice";
import downloadAttachments from "../Functions/downloadAttachments";
import ConfirmationModal from "../components/ConfirmModal/ConfirmationModal";
import InvoiceGuideLine from "../views/Invoices/NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import TaxDetail from "../views/Invoices/Components/TaxDetails/TaxDetails";
import TaxTable from "../views/Invoices/NewInvoice/Tables/Tax_Table";
import UsersByRole from "../views/Invoices/NewInvoice/Dropdowns/UsersByRole";
import GL_Table from "../views/Invoices/NewInvoice/Tables/GL_Table";
import GL_Table_V2 from "../views/Invoices/NewInvoice/Tables/GL_Table_V2";
import InvoiceCheckboxes from "../views/Invoices/Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../views/Invoices/Components/InvoiceDetails/InvoiceRadiobuttons";
import ExpenseTable from "../views/Invoices/NewInvoice/Tables/ExpenseTable";
import POAlertDialog from "../views/Invoices/NewInvoice/Tables/PoTableAlert";
import WarningBox from "../views/Invoices/Components/WarningBox";
import PageNotFound from "../views/Invoices/NewInvoice/PageNotFound";
import CloseIcon from "@material-ui/icons/Close";
import DepartmentCoordinatorRent from "../views/Invoices/DepartmentCoordinator/DepartmentCoordinatorRent";
import RTBLineItems_Table from "../views/Invoices/NewInvoice/Tables/RTBLineItems_Table";
const useStyles = makeStyles(dashboardStyle);
const LoamInvoice = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [poBasedState, setPoBasedState] = useState("PO");
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const status = getParameterByName("status");
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [roles, setRoles] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [attachmentURL, setAttachmentURL] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [SelectedReviewerList, setSelectedReviewerList] = useState([]);
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  const [Post, setPost] = useState(true);
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [disabled, setDisabled] = useState(false);
  const additionalAttachmentRef = useRef(null);
  const invoice_attachmentRef = useRef(null);
  const [docError, setDocError] = useState("");
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredUserData,setFilteredUserData ]= useState([]);
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    if (invoicePayload.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload.Invoice_id,
        status,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload.Invoice_id, status]);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    po_Date: "",
    plant_Code: "",
    taxCard_List: [],
    invoice_Accounts_list: [],
    invoice_id: invoicePayload?.Invoice_id,
    additionalDocs: [],
    //  rtbId : "",
    invoice_Accounts: [
      // {
      // //   accountId: 0,
      // //   invoice_Id: 0,
      // //   glAccount: " ",
      // //   costCenter: " ",
      // //   accountType: " ",
      // //   amount: 0,
      // //   costCenterOwner: " ",
      // //   stCode: " ",
      // //   order: " ",
      // //   profitCenter: " ",
      // //   wbsElement: " ",
      // //   created_By: " ",
      // //   created_On: "2022-12-08T10:26:43.808Z",
      // //   updated_By: " ",
      // //   updated_On: "2022-12-08T10:26:43.808Z",
      // //   fixedAsset: " ",
      // //   tType: " ",
      // //   description: " ",
      // //   expenseDate: " ",
      // //   horizonId: " ",
      // //   department: " ",
      // //   vendorCode: " "
      // }
    ],
    isReject: false,
    createdBy: " ",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: [],
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    mpasEFDV : false ,
    
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    due_Date: new Date(),
provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    additionalDocIds_array: [], // additional documents in array
    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },
    // Tax Table data
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      {
        accountId: 0,
        invoice_Id: 0,
        glAccount: "",
        costCenter: "",
        accountType: "",
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: "",
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the  table component.
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],
    verified: false,
  });
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [multipleData, setMultipleData] = useState({
    glAccount: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    invoice_Type: [],
  });

  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    taxCard_List: [],
    invoice_Accounts_list: [],
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    invoice_id: invoicePayload?.Invoice_id,
    additionalDocs: [],
    comments: "",
    invoice_Accounts: [
      // {
      // //   accountId: 0,
      // //   invoice_Id: 0,
      // //   glAccount: " ",
      // //   costCenter: " ",
      // //   accountType: " ",
      // //   amount: 0,
      // //   costCenterOwner: " ",
      // //   stCode: " ",
      // //   order: " ",
      // //   profitCenter: " ",
      // //   wbsElement: " ",
      // //   created_By: " ",
      // //   created_On: "2022-12-08T10:26:43.808Z",
      // //   updated_By: " ",
      // //   updated_On: "2022-12-08T10:26:43.808Z",
      // //   fixedAsset: " ",
      // //   tType: " ",
      // //   description: " ",
      // //   expenseDate: " ",
      // //   horizonId: " ",
      // //   department: " ",
      // //   vendorCode: " "
      // }
    ],
    isReject: false,
    createdBy: " ",
    // LogisticInvoices: false,
    // VendorPrePayment: false,
    // VendorFinancingPayment: false,
    loamReviewer: [],
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,
    isProceed: false,

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      {
        accountId: 0,
        invoice_Id: 0,
        glAccount: "",
        costCenter: "",
        accountType: "", // D/C (debit/ credit)
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: "",
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const getUsers = async () => {
    setLoading(true);
    getUsersByRole("Reviewer", setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);
  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };
  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };
  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const submitHandler = (e) => {
    //

    e.preventDefault();
    setConfirmationModal(true);
    setConfirmationMessage("Are you sure to proceed the Invoice ");
    // updateIPInvoice(
    //   newFormState,
    //   setNewFormState,
    //   poBasedState,
    //   setErrorMessage,
    //   setSuccessMessage,
    //   setAttachInvoiceLoading,
    //   navigate
    // );
  };
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    if (invoicePayload && role) {
      getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      getAllInvoiceDetailByInvoiceIdForDCReviewer(
        setFormState,
        setMultipleData,
        invoicePayload?.Invoice_id,
        () => {},
        () => {},
        () => {},

        () => {},
        setSelectedReviewerList
      );
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
    }
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getUserRoles(setRoles, setRolesLoading);
  }, []);

  const [vendor__Code, setVendor__Code] = useState("");

  const [vendor__Name, setVendor__Name] = useState("");
  useEffect(() => {
    if (formState?.vendor_Code) {
      setVendor__Code(formState?.vendor_Code);
    } else {
      setFormState((formState) => ({
        ...formState,
        vendor_Code: vendor__Code,
      }));
    }
    if (formState?.vendor_Name) {
      setVendor__Name(formState?.vendor_Name);
    } else {
      setFormState((formState) => ({
        ...formState,
        vendor_Name: vendor__Name,
      }));
    }
  }, [formState.vendor_Code]);
  // useEffect(() => {
  //   if (formState?.invoice_Accounts_list?.length > 0) {
  //     let temp = [];
  //     for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
  //       const item = formState?.invoice_Accounts_list[i];
  //       const obj = {
  //         accountId: 0,
  //         invoice_Id: Number(invoicePayload?.Invoice_id),
  //         expenseDate: item?.ExpenseDate,
  //         glAccount: item?.GLAccount,
  //         GLAccount: item?.GLAccount,
  //         costCenter: item?.CostCenter,
  //         costCenterOwner: item?.CostCenterOwner,
  //         costCenterOwnerName: item?.CostCenterOwnerName,
  //         wbsElement: item?.WBSElement,
  //         horizonId: item?.HorizonId,
  //         vendorCode: item?.VendorCode,
  //         amount: Number(item?.Amount),
  //         profitCenter: Number(item?.ProfitCenter),
  //         department: item?.Department,
  //       };
  //       temp.push(obj);
  //     }
  //     setNewFormState((formState) => ({
  //       ...formState,
  //       invoice_Accounts_list: temp,
  //       Expense_Accounts_list: temp,
  //     }));
  //   }
  // }, [formState]);
  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.ExpenseDate,
          glAccount: item?.GLAccount,
          GLAccount: item?.GLAccount,
          accountType: item?.AccountType,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenter: item?.CostCenter,

          costCenterOwner: item?.CostCenterOwner,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendorCode: item?.VendorCode,
          amount: Number(item?.Amount),
          profitCenter: Number(item?.ProfitCenter),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
        };
        temp.push(obj);
      }
      setNewFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: temp,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState]);
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [openWarningBox, setOpenWarningBox] = useState(false);
  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additionalDocs.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additionalDocs: files,
        }));

        setdeleteLoader(false);
        setOpenWarningBox(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };

  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "additionalDocs",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  useEffect(()=>{ 
    const selectedUserIds = newFormState.loamReviewer;
    const newFilteredData = userData?.filter(user => !selectedUserIds?.includes(user?.userId));
    setFilteredUserData(newFilteredData);
  },[newFormState])

  useEffect(()=>{
    setFilteredUserData(userData)
  },[userData])

  return (
    <>
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={dragloader || pageLoader}
          ></Backdrop>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "0px 27px",
                backgroundColor: "#031C30",
                color: "white",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={2} sm={3} md={3} lg={6}>
                  <h1 style={{ fontSize: "24px" }}>Loam Approver</h1>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <CardBody>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={attachInvoiceLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container style={{ marginTop: "1px" }}>
              {/* Submitter role */}
              <Grid item xs={12} sm={12} md={3} lg={3} mt={2}>
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span> Submitter Role:
                </Typography>
                <Autocomplete
                  id="submitter_role"
                  options={roles}
                  size="small"
                  value={selectedRole}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.roleName}`) || ""
                  }
                  loading={rolesLoading}
                  onChange={(event, newValue) => {
                    roleHandler(newValue);
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
            </Grid>
            {!formState.isImport && !formState?.isPCDV && (
              <InvoiceCheckboxes
                formState={formState}
                setFormState={setFormState}
                selectedRole="Loam Approver"
                disabled={true}
              />
            )}
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                {!formState.isImport && !formState?.isPCDV && (
                  <InvoiceRadioButtons
                    formState={formState}
                    setFormState={setFormState}
                    selectedRole="Loam Approver"
                    physicalOrEInvoice={physicalOrEInvoice}
                    poBasedState={poBasedState}
                    alignForAttachment={true}
                  />
                )}

                <InvoiceTextField
                  newFormState={formState}
                  setNewFormState={setFormState}
                  selectedRole="Loam Approver"
                  disabled={true}
                  poBasedState={poBasedState}
                  showVendorAndPO_NumberForImport={
                    showVendorAndPO_NumberForImport
                  }
                  showVendorCodeForImport={showVendorCodeForImport}
                  invoice_attachmentRef={invoice_attachmentRef}
                  additionalAttachmentRef={additionalAttachmentRef}
                  setAttachInvoiceLoading={setAttachInvoiceLoading}
                  // setAttchmentFile_UI={setAttchmentFile_UI}
                  // attachmentFile_UI={attachmentFile_UI}
                  physicalOrEInvoice={physicalOrEInvoice}
                  changeHandler={changeHandler}
                  alignForAttachment={true}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURLList={attachmentURLList}
                  setAttachmentURL={setAttachmentURL}
                  showAttachmentsHandler={showAttachmentsHandler}
                  multipleData={multipleData}
                  // edit={false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <Heading
                  title=" Attachment Preview"
                  style={{ marginLeft: "7px" }}
                />

                <AttachmentsCover
                  attachmentURLList={attachmentURLList}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURL={attachmentURL}
                  setAttachmentURL={setAttachmentURL}
                />
              </Grid>
            </Grid>
            <form onSubmit={submitHandler} style={{ marginTop: "50 px" }}>
              {/* {!formState.isImport && poBasedState === "Non-PO" && ( */}
              <>
                {!formState.isImport &&
                  poBasedState === "Non-PO" &&
                  !formState?.isPCDV &&
                  !formState.skipTaxStep && (
                    <>
                      <Typography variant="h4">Tax:</Typography>
                      <TaxDetail
                        formState={newFormState}
                        setFormState={setNewFormState}
                        invoice_Amount={newFormState.invoice_Amount}
                        disabled={true}
                      />
                      <TaxTable
                        formState={formState}
                        setFormState={setFormState}
                        invoice_Amount={formState.invoice_Amount}
                        invoicePayload={invoicePayload}
                        show={true}
                        edit={false}
                      />
                    </>
                  )}
                <span></span>
                {!formState.isImport && !formState?.isPCDV && (
                  <>
                    <Typography
                      variant="h4"
                      style={{ margin: "20px 0px 10px 0px" }}
                    >
                      <Heading title=" G/L Account " />
                    </Typography>
                    {
                      newFormState?.invoice_Type === 'Final Settlement - Distributor' ?
                        <GL_Table_V2
                        data={formState?.invoice_Accounts_list}
                          formState={newFormState}
                          setFormState={setNewFormState}
                          show={false}
                          reviwerFlag={ true }
                          role={selectedRole}                        /> 
                  :
                <GL_Table
                      formState={newFormState}
                      setFormState={setNewFormState}
                      show={true}
                      reviwerFlag={true}
                    />
                        }
                    {
  formState?.isDeptCordinator && formState?.invoice_Type === 'Rent' && (
    <DepartmentCoordinatorRent 
      formState={formState}
      setFormState={setFormState}
      show={false}
      reviwerFlag={true}
      role={
        (selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type === 'Rent')
          ? ""
          : "HR"
      }
    />
  )
}

                  </>
                )}
                 {/* {(
                  formState?.rtbId
                ) && (
                  <Grid container spacing={2} marginY={2}>
                    <Grid item xs={12}>
                      <RTBLineItems_Table
                      formState={formState}
                      setFormState={setFormState}
                      setSelectedTotal={() => {}}
                      selectedRole={selectedRole}
                      />
                    </Grid>
                  </Grid>
                )} */}
              </>
              {/* )} */}
              {/* ExpenseTable */}
              {formState?.isPCDV && (
                <Grid
                  container
                  style={{ marginTop: "5px", padding: "0px 5px" }}
                >
                  <Grid item xs={12} sm={12} md={6} lg={12}>
                    <ExpenseTable
                      formState={newFormState}
                      setFormState={setNewFormState}
                      editable={false}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <CommentHistory
                  commentsList={commentsList}
                  commentsLoading={commentsLoading}
                />
              </Grid>
              <Grid container style={{ marginTop: "20px" }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid container spacing={1}>
                    {/* Additional Documents */}
                    <Grid item xs={12} sm={12} md={12} lg={3}>
                      <Typography style={{ color: "black" }}>
                        Additional Documents:{" "}
                        {/* <span className={classes.asterisk}>*</span> */}
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        // onChange={() => }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <input
                                ref={additionalAttachmentRef}
                                type="file"
                                name="additionalDocs"
                                // accept=".png, .jpg, .jpeg, .pdf"
                                // required={
                                //   newFormState?.isReject === false
                                //     ? newFormState?.additionalDocIds.length === 0
                                //     : false
                                // }
                                onChange={(e) =>
                                  uploadAdditioalDocumentFile(
                                    e,
                                    setNewFormState,
                                    setAttachInvoiceLoading,
                                    "additionalDocs",
                                    additionalAttachmentRef,
                                    setDocError,
                                    setAttachError,
                                    setAlertMessage,
                                    invoicePayload,
                                    selectedRole,
                                    dragfile,
                                    setDragFile,
                                    setSuccessMessage
                                  )
                                }
                                style={{ width: "209px" }}
                                multiple
                              />
                            </InputAdornment>
                          ),
                        }}
                        FormHelperTextProps={{
                          className: classes.helperText,
                        }}
                        // error={docError ? true : false}
                        // helperText={docError ? `${docError}` : null}
                      />
                      {newFormState?.additionalDocs.length > 0 &&
                        newFormState?.additionalDocs?.map((f, index) => {
                          const s = f?.path?.split("\\");
                          const ss = s[s.length - 1];
                          return (
                            <>
                              {f?.path !== "" ? (
                                <>
                                  {!disabled && (
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setInvoiceDelete(f);
                                        setOpenWarningBox(true);
                                      }}
                                    >
                                      <Delete
                                        color="danger"
                                        fontSize="small"
                                        style={{
                                          color:
                                            f.role_Name !==
                                            selectedRole?.roleName
                                              ? "gray"
                                              : "",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                  <IconButton>
                                    <Download
                                      onClick={() => {
                                        const files =
                                          newFormState.additionalDocs.find(
                                            (x, i) => {
                                              const n = x?.path?.split("\\");
                                              const nn = n[n.length - 1];
                                              return nn === ss;
                                            }
                                          );
                                        downloadAttachments(files?.path);
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      const extension = f.path
                                        ?.match(/\.[^.]+$/)[0]
                                        .substring(1);

                                      const allowedExtensions = [
                                        ".png",
                                        ".pdf",
                                        ".jpg",
                                        ".jpeg",
                                        ".PNG",
                                        ".JPG",
                                        ".JPEG",
                                        ".PNG",
                                        ".PDF",
                                      ];
                                      const fileExtension =
                                        "." + ss.split(".").pop();
                                      if (
                                        allowedExtensions.includes(
                                          fileExtension
                                        )
                                      ) {
                                        setAttachmentURL(f);
                                      } else {
                                        if (isContainEmailFormate(extension)) {
                                          downloadAttachments(f.path);
                                        } else {
                                          setAttachmentURL(f);

                                          window.open(
                                            `${process.env.REACT_APP_API_URL}/${f.path}`,
                                            "_blank"
                                          );
                                        }
                                      }
                                    }}
                                  >
                                    <span style={{ fontSize: "10px" }}>
                                      {ss}
                                    </span>
                                  </IconButton>
                                  <div></div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}
                    </Grid>

                    {/* Add Reviewer */}
                    {(!newFormState?.isImport && !newFormState?.isPCDV) && (
                      <Grid item xs={12} sm={12} md={6} lg={3}>
                        <Typography style={{ color: "black" }}>
                          {" "}
                          Add Reviewer:{" "}
                          <span className={classes.asterisk}></span>
                        </Typography>
                        <Autocomplete
                          multiple
                          options={filteredUserData}
                          getOptionLabel={(option) => option.userName}
                          getOptionDisabled={(option) =>
                            SelectedReviewerList.includes(option?.userId)
                          }
                          value={
                            newFormState.loamReviewer.map((reviewerId) =>
                              userData.find((user) => user.userId === reviewerId)
                            )
                          }
                          loading={loading}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setNewFormState((prevFormState) => ({
                                ...prevFormState,
                                loamReviewer: newValue.map(
                                  (user) => user?.userId
                                ),
                              }));
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              size="small"
                              fullWidth
                              placeholder="Select Reviewers"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                key={index}
                                label={option?.userName}
                                onDelete={() => {
                                  // Remove the selected user from loamReviewer
                                  const updatedReviewers = newFormState.loamReviewer.filter(
                                    (userId) => userId !== option.userId
                                  );
                                  setNewFormState((prevFormState) => ({
                                    ...prevFormState,
                                    loamReviewer: updatedReviewers,
                                  }));
                                }}
                                deleteIcon={<CloseIcon />}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "#e0e0e0", // Set your desired background color
                                  padding: "2px", // Set padding
                                  marginRight: "4px", // Set margin between tags
                                }}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                        />
                        {/* <UsersByRole
                        label="Add Reviewer"
                        placehold="Select a  Reviewer"
                        apiString="Reviewer"
                        name="loamReviewer"
                        formState={newFormState}
                        changeHandler={changeHandler}
                        required={false}
                        disabled={false}
                        classes={classes}
                      /> */}
                        {/* <FormControl fullWidth size="small">
                     
                      <TextField
                        name="loamReviewer"
                        value={newFormState.loamReviewer}
                        variant="outlined"
                        required={false}
                        onChange={changeHandler}
                        label={
                          newFormState.loamReviewer.length === 0
                            ? "Select a Reviewer"
                            : ""
                        }
                        InputLabelProps={{
                          shrink: false,
                          required: false,
                          className: classes.hs_form_required,
                        }}
                        select
                        SelectProps={{ multiple: true }}
                        fullWidth
                        size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select a Reviewer
                        </MenuItem>
                        {!loading ? (
                          userData.length > 0 ? (
                            userData.map((item, index) => (
                              <MenuItem key={index} value={item.userId}
                              disabled={SelectedReviewerList?.includes(item?.userId)}
                              >
                                {item.userName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Not Found</MenuItem>
                          )
                        ) : (
                          <MenuItem>
                            <CircularProgress size={24} />
                          </MenuItem>
                        )}
                      </TextField>
                    </FormControl> */}
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Button color="secondary" variant="contained" sx={{ mt: 3 }}>
                    Add Another Reviewer
                  </Button>
                </Grid> */}

                    {/* Additional Details */}
                  </Grid>
                  <Grid
                    container
                    style={{ margin: "20px 0px", padding: "0px 5px" }}
                  >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography style={{ color: "black" }}>
                        comments:
                        {newFormState?.isReject ? (
                          <span className={classes.asterisk}>*</span>
                        ) : (
                          ""
                        )}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        name="comments"
                        required={newFormState?.isReject}
                        value={newFormState.comments}
                        onChange={(e) => {
                          setNewFormState((newFormState) => ({
                            ...newFormState,
                            comments: e.target.value,
                          }));
                        }}
                      />
                    </Grid>
                    {!formState.isImport && poBasedState === "Non-PO" && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography style={{ color: "black" }}>
                          Additional Details:
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={2}
                          maxRows={4}
                          // size="small"
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          name="aditional_Comments"
                          required={
                            newFormState?.isProceed && poBasedState == "PO"
                          }
                          value={newFormState.aditional_Comments}
                          onChange={(e) => {
                            setNewFormState((newFormState) => ({
                              ...newFormState,
                              aditional_Comments: e.target.value,
                            }));
                          }}
                        />
                      </Grid>
                    )}
                    {(Post && allowToProceed) && (
                      <Box display="flex" justifyContent={"flex-end"} mt={2}>
                        <Button
                          color="error"
                          variant="contained"
                          type="submit"
                          onClick={() =>
                            setNewFormState((newFormState) => ({
                              ...newFormState,
                              isReject: true,
                              isProceed: false,
                            }))
                          }
                        >
                          Reject
                        </Button>
                        <Button
                          color="secondary"
                          variant="contained"
                          type="submit"
                          sx={{ ml: 2 }}
                          onClick={() =>
                            setNewFormState((newFormState) => ({
                              ...newFormState,
                              isReject: false,
                              isProceed: true,
                            }))
                          }
                        >
                          Approve
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </CardBody>
          {confirmationModal && (
            <ConfirmationModal
              open={confirmationModal}
              close={() => setConfirmationModal(false)}
              message={confirmationMessage}
              submit={() => {
                setAttachInvoiceLoading(true);
                LoamPutInvoice(
                  newFormState,
                  setNewFormState,
                  setErrorMessage,
                  setSuccessMessage,
                  setAttachInvoiceLoading,
                  navigate,
                  setConfirmationModal,
                  setPost
                );
              }}
              loading={attachInvoiceLoading}
            />
          )}

          {openInvoiceGuideLine && (
            <InvoiceGuideLine
              open={openInvoiceGuideLine}
              close={setOpenInvoiceGuideLine}
            />
          )}
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}
          {errorMessage && (
            <>
              {" "}
              <Grid container spacing={0}>
                <Grid item ml={4}>
                  <Error
                    titleAccess="Error"
                    className={classes.asterisk}
                    fontSize="small"
                  />{" "}
                </Grid>
                <Grid item>
                  <Typography className={classes.asterisk} ml={1}>
                    {" "}
                    {errorMessage}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={attachError ? attachError : docError}
              setErrAlertMessage={() => {}}
            />
          )}
          {openWarningBox && (
            <WarningBox
              open={openWarningBox}
              close={() => setOpenWarningBox(false)}
              submit={deleteAttachmentFunc}
              message="Are you sure to delete attachment"
              deleteLoader={deleteLoader}
              allow={1}
            />
          )}
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </>
  );
};

export default LoamInvoice;
